<template>
    <div>
        <!-- <div class="tab" :class="navBarFixed ? 'navBarFixed' : ''">
      <img
        @click="goback"
        src="../../../../static/common/logoBlack.png"
        alt=""
      />
    </div> -->
        <div class="tabNew" v-if="tabBar" :class="navBarFixed ? 'navBarFixed' : ''">
            <div class="tabTop">
                <div>
                    <ul>
                        <img class="hongshi" src="../../../../static/common/wap/hongshi.png" alt="">
                        <p>
                            <span style="font-weight:600;font-size:0.16rem;">红狮启富</span>
                            <span>应用版本：5.0.0</span>
                            <span>更新时间：2024年09月02日</span>
                        </p>
                    </ul>
                    <img @click="downLoadApp" class="downLoadApp" src="../../../../static/common/wap/downloadApp.png"
                        alt="">
                </div>
            </div>
            <p class="tabBottom">
                <span>应用权限:查看权限 隐私权限: 查看权限</span>
                <span>APP开发者: 香港红狮集团有限公司 应用名称:红狮启富</span>
            </p>
            <img @click="() => { tabBar = false; }" class="closer" src="../../../../static/common/wap/closer.png" alt="">
        </div>
        <div class="step_1">
            <div class="signup">
                <input v-model="form.phone" type="text" placeholder="请输入手机号">
                <div class="codeBox">
                    <input v-model="form.code" type="text" placeholder="请输入验证码">
                    <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                    <span v-else>重新获取({{ verSecond }})</span>
                </div>
                <button @click="submit(form)"></button>
            </div>
            <div v-if="controlImgCodeDialog" class="codeDialog">
                <img :src="imgcodelocal" alt="">
                <p>
                    <span>图形验证码:</span>
                    <input type="text" v-model="form.codeNumber">
                </p>
                <div>
                    <button @click="() => { this.controlImgCodeDialog = false }">取消</button>
                    <button @click="confirm(form.codeNumber)">确定</button>
                </div>
            </div>
            <div class="step_2">
                <div class="rules" @click="rulesModel = true">活动规则</div>
                <div class="box" @click="getActivity"></div>
                <div class="text">首入$100即送，最高兑换$5/手</div>
                <img @click="getActivity" src="/activity/czzj_6357/wap/s3.png" alt="" />
            </div>
            <div class="step_3">
                <div class="btn">
                    <div @click="getLive800"></div>
                    <div @click="getActivity"></div>
                </div>
            </div>
            <div class="step_4">
                <div @click="getActivity"></div>
            </div>
            <div class="step_5">
                <img class="box" src="/activity/czzj_6357/wap/s6.png" alt="" />
                <div class="btnBox">
                    <div class="item">
                        <span>咨询客服，获取最新版官方APP</span>
                        <img @click="getLive800" src="/activity/czzj_6357/wap/s7.png" alt="" />
                    </div>
                    <div class="item">
                        <span>盈利的快乐 这个春天你要知道</span>
                        <img @click="getActivity" src="/activity/czzj_6357/wap/s8.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" v-if="rulesModel">
            <div class="popup">
                <div class="closeBox">
                    <img class="guanbi1" @click="rulesModel = false" src="/activity/czzj_6357/wap/s9.png" alt="" />
                </div>
                <ul class="dialogContent">
                    <li>
                        <span>活动对象：</span>
                        活动期间，在本平台开立真实账户，并首次入金的客户
                    </li>
                    <li>
                        <span>活动时间：</span>
                        即日起至2023年03月31日23:59
                    </li>
                    <li>
                        <span>活动规则：</span><br />
                        首次充值，充多少送多少美元赠金，奖励上不封顶；<br />
                        72小时内总入金≥500美元，可额外获得100美元现金；<br />
                        首入金奖励如下：
                        <table>
                            <tr>
                                <th>层级</th>
                                <th>首入条件<br />(72h内)</th>
                                <th>美元赠金<br />(100%赠送)</th>
                                <th>美元现金<br />(限时送)</th>
                                <th>美元现金提现条件<br />(30天内)</th>
                                <th>总获赠金额</th>
                            </tr>
                            <tr>
                                <th>1</th>
                                <th>总入金＜$500</th>
                                <th>＜$500</th>
                                <th>无</th>
                                <th>无</th>
                                <th>＜500美元赠金</th>
                            </tr>
                            <tr>
                                <th>2</th>
                                <th>总入金≥$500</th>
                                <th>≥$500</th>
                                <th>100</th>
                                <th>≥10手</th>
                                <th>≥500美元赠金<br />+100美元现金</th>
                            </tr>
                            <tr>
                                <th></th>
                                <th></th>
                                <th>充多少 送多少</th>
                                <th>100</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </table>
                    </li>
                    <li>
                        <span>美元赠金：</span><br />
                        1、活动期间内，首次入金可获得等额的美元赠金（即赠金点）回馈；<br />
                        2、 首入金有效期为第一笔入金后的72h内，赠送金额将按照72h后最终数额计算；<br />
                        3、用户每交易一手伦敦金/伦敦银，返还相对应的赠金金额；该笔资金可交易可提现，用户可登录App-我的-赠金奖励中查看（未满一手按照实际交易手数占一手的比例计算）<br />
                        4、美元赠金按交易手数返还，当月交易越多，每手返还越高！<br />
                        <span style="color:#00c1eb;font-weight: 500;">更多活动详情，请下载App-我的-赠金奖励中查看，或咨询客服。</span>
                    </li>
                    <li>
                        <span>美元现金：</span><br />
                        1、美元现金直接入账，可交易，可提现；<br />
                        2、用户在30天内完成≥10手交易即可提现，品种限伦敦金/伦敦银；<br />
                        3、30天内未完成手数要求，活动到期时，系统仅扣回美元现金金额。<br />
                        举例说明：A女士，入金520美元，获得100美元现金，账户实际到账金额为520+100=620美元，第15天，A女士完成10手交易，顺利提取100美元现金。<br />
                    </li>
                    <li>
                        <span>注意事项：</span><br />
                        1. 客户参与活动需在本公司开立真实交易账户,参与该活动的新用户，为保证资金安全，在初始L1层级，账户强平比例上调至50%，升级后自动恢复为20%；<br />
                        2. 交易手数计算：开仓一手平仓一手，如此来回算一手；<br />
                        3. 本活动本公司新客户仅有一次机会参与，不可重复领取；<br />
                        4. 凡推广商及其名下客户不参与本活动；<br />
                        5.
                        本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。
                    </li>
                </ul>
            </div>
        </div>
        <div class="bottomBar" v-if="tabBar">
            <p>
                <img src="../../../../static/common/wap/call.png" alt="">
                <span @click="getLive800">咨询客服</span>
            </p>
            <p>
                <img src="../../../../static/common/wap/dollars.png" alt="">
                <span @click="goLogin">立领$10000+$500新课礼包</span>
            </p>
        </div>
    </div>
</template>
<script>
import { verifyImgCode, quickRegister } from '../../../../api/info';
import { getGuid } from '../../../../utils/guid';
import userSign from '@/mixins/userSign';

export default {
    name: "czzj_6357_wapNew",
    mixins: [userSign],

    data() {
        return {
            form: {
                phone: '',
                code: '',
                codeNumber: '',
            },
            rulesModel: false,
            navBarFixed: false,
            // 控制显示验证码或读秒
            verControl: true,
            // 定时器倒计时
            refreshData: null,
            // 验证码读秒数
            verSecond: 60,
            // 控制图片验证码弹窗
            controlImgCodeDialog: false,
            // 图片验证码地址
            imgcodelocal: '',
            guid: '',
            tabBar: true,
        };
    },
    created() {
        this.$emit("controlShow", false);
        this.$emit('controlBottom', false);
        if (document.body.clientWidth > 500) {
            this.$router.push({
                name: "czzj_6357",
            });
        }
    },
    methods: {
        // 返回上级页面
        goback() {
            window.location.href = window.location.origin;
        },
        getActivity() {
            window.open("https://www.rlcvipltd.net/uc/signUp/real");
        },
        getLive800() {
            // window.open(
            //   "https://chat32.live800.com/live800/chatClient/chatbox.jsp?companyID=215184&configID=35519&jid=5377035377"
            // );
            window.open(this.$parent.live800Url)
        },
        goLogin() {
            window.open('https://www.rlcvipltd.net/uc/login');
        },
        
        // 读秒
        countdowm() {
            this.refreshData = window.setInterval(() => {
                this.verSecond--;
                if (this.verSecond < 0) {
                    //当倒计时小于0时清除定时器
                    window.clearInterval(this.refreshData); //清除定时器
                    this.verSecond = 60;
                    this.verControl = true;
                }
            }, 1000);
        },
        // 正则判断电话号码格式是否正确
        isPhone(TEL) {
            let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (strTemp.test(TEL)) {
                return true;
            }
            return false;
        },
        // 点击下载app
        downLoadApp() {
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
                try {
                    window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
                } catch (error) {
                    window.open('https://apps.apple.com/cn/app/id1598072476');
                }
            } else { // 安卓
                try {
                    window.android.gotoRegisterReal();
                } catch (error) {
                    window.open('https://oss.0790jiaxiao.com/HS/software/hs_9999.apk');
                }
            }
        },
        submit(form) {
      if (form.phone && form.code) {
        this.handleRegister().then(() => {
          setTimeout(() => {
            this.toUserCenter();
          }, 500)
        }).catch(() => {
        })
      } else {
        this.$message({
          message: '请输入手机号和验证码！',
          type: 'warning',
        });
       
      }
    },
    },
};
</script>

<style lang="less" scoped>
.tab {
    width: 7.5rem;
    height: 50px;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;

    img {
        width: 120px;
    }
}

.step_1 {
    width: 100%;
    height: 63rem;
    box-sizing: border-box;
    padding-top: 4rem;
    background: url("/activity/czzj_6357/wap/s1.jpg") no-repeat;
    background-size: 100% 100%;

    .signup {
        width: 95%;
        height: 4.2rem;
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 0.95);
        box-sizing: border-box;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 4.35rem auto 0;

        input:focus {
            outline: none;
        }

        input {
            width: 85%;
            height: 0.78rem;
            background: #fff;
            border: 1px solid #1ba67d;
            border-radius: 8px;
            font-size: 16px;
            margin-bottom: 20px;
            text-indent: 15px;
            list-style: none;
        }

        .codeBox {
            width: 100%;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                width: 2.08rem;
                height: 0.82rem;
                font-size: 16px;
                border-radius: 8px;
                background-color: #1ba67d;
                text-align: center;
                color: #fff;
                position: absolute;
                top: 1px;
                right: 0.50rem;
                cursor: pointer;
                background: url('/activity/czzj_6357/wap/code.png') no-repeat;
                background-size: 100% 100%;
                line-height: 0.83rem;
                font-size: 0.34rem;
            }
        }

        button {
            width: 70%;
            height: 1.55rem;
            cursor: pointer;
            background: url('/activity/czzj_6357/wap/s3.png') no-repeat;
            background-size: 100% 100%;
            border: none;
            margin-top: -20px;
        }
    }

    .codeDialog {
        width: 95%;
        height: 4.5rem;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #fef6e9;
        border-radius: 15px;
        z-index: 99;
        border: 1px solid #ffd8a6;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;

        img {
            width: 3rem;
            margin-bottom: 0;
        }

        p {
            margin: 0.2rem auto;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                color: #1ba67d;
                font-size: 0.32rem;
                font-weight: 600;
            }

            input {
                width: 2.5rem;
                height: 0.8rem;
                background-color: #ffffff;
                border: none;
                margin-left: 0.2rem;
                text-indent: 0.2rem;
                font-size: 0.32rem;
                color: #1ba67d;
            }
        }

        div {
            display: flex;
            justify-content: center;
            align-items: center;

            button {
                width: 2rem;
                height: 0.8rem;
                border: 1px solid #ff8038;
                background-color: #ffffff;
                color: #ff8038;
                font-size: 0.3rem;
                border-radius: 8px;
                margin: 0 10px;
            }

            button:nth-child(2) {
                background-color: #ff8038;
                color: #ffffff;
            }
        }
    }
}

.step_2 {
    width: 94%;
    height: 8.5rem;
    background: url("/activity/czzj_6357/wap/s2.png") no-repeat center;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 1.3rem;
    box-sizing: border-box;
    padding-top: 1.3rem;
    text-align: center;

    .rules {
        color: #0d7260;
        font-size: 0.38rem;
        cursor: pointer;
        text-align: center;
        font-weight: 600;
    }

    .box {
        width: 100%;
        height: 1rem;
        margin-top: 3rem;
    }

    .text {
        color: #0d7260;
        font-size: 0.38rem;
        font-weight: 600;
        text-align: center;
        margin-top: 0.5rem;
    }

    img {
        height: 1.5rem;
        margin-top: 0.15rem;
    }
}

.step_3 {
    width: 94%;
    height: 16rem;
    background: url("/activity/czzj_6357/wap/s4.png?v=0227") no-repeat center;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 0.55rem;
    box-sizing: border-box;
    padding-top: 16.5rem;
    text-align: center;

    .btn {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin: 0 auto;

        div {
            width: 40%;
            height: 1.5rem;
        }
    }
}

.step_4 {
    width: 94%;
    height: 8.4rem;
    background: url("/activity/czzj_6357/wap/s5.png") no-repeat center;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 0.55rem;
    box-sizing: border-box;
    padding-top: 5.5rem;

    div {
        float: right;
        width: 60%;
        height: 1.5rem;
    }
}

.step_5 {
    width: 94%;
    margin: 0 auto;
    margin-top: 0.55rem;

    .box {
        width: 100%;
    }

    .btnBox {
        width: 100%;

        .item {
            height: 0.8rem;
            line-height: 0.8rem;
            margin-top: 0.4rem;

            span {
                float: left;
                color: #fff;
                font-size: 0.3rem;
                font-weight: 600;
            }

            img {
                height: 0.8rem;
                float: right;
            }
        }
    }
}

.mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    top: 0;
}

.popup {
    width: 95%;
    height: 12rem;
    border-radius: 0.3rem;
    background: #e9f7f7;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%; -50%);
    box-sizing: border-box;
    padding: 10px;
    box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);
    overflow-y: scroll;
    z-index: 99999999999999;

    .closeBox {
        height: 0.5rem;

        .guanbi1 {
            float: right;
            height: 0.5rem;
            cursor: pointer;
            margin-right: 0.1rem;
        }
    }

    .dialogContent {
        box-sizing: border-box;
        padding: 0.2rem 0.1rem;

        li {
            font-size: 0.3rem;
            color: #599b8f;
            line-height: 0.57rem;

            span {
                font-weight: 600;
                color: #0d7260;
            }

            img {
                width: 100%;
                height: auto;
                margin: 20px 0;
            }

            table {
                border: 1px solid #0d7260;
                border-radius: 0.1rem;

                tr {
                    th {
                        text-align: center;
                        border-bottom: 1px solid #599b8f;
                        border-right: 1px solid #599b8f;
                        padding: 0.05rem;
                        line-height: 0.4rem;
                        font-size: 0.2rem;
                        font-weight: 500;
                    }

                    th:last-child {
                        border-right: 1px solid transparent;
                    }

                    &:last-child {
                        th {
                            border-bottom: none;
                        }
                    }
                }

                tr:nth-child(1) {
                    th {
                        font-weight: 600;
                    }
                }
            }
        }
    }
}

::-webkit-scrollbar {
    width: 0px;
}

::-webkit-scrollbar-track {
    background-color: none;
}

::-webkit-scrollbar-thumb {
    background-color: none;
}

::-webkit-scrollbar-thumb:hover {
    background-color: none;
}

::-webkit-scrollbar-thumb:active {
    background-color: none;
}

.tabNew {
    width: 7.50rem;
    height: 1.78rem;
    background: url('../../../../static/common/wap/tab.png') no-repeat;
    background-size: cover;
    box-sizing: border-box;
    padding: 0 0.1rem 0 0.1rem;

    // position: relative;
    .tabTop {
        width: 100%;
        height: 1.02rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        div {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            ul {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0;

                .hongshi {
                    width: 0.75rem;
                    margin: 0 0.2rem;
                }

                p {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    font-size: 0.12rem;
                }
            }

            .downLoadApp {
                width: 2.03rem;
                margin-top: 0.2rem;
                margin-right: 0.2rem;
            }
        }
    }

    .tabBottom {
        font-size: 0.10rem;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        box-sizing: border-box;
        padding-left: 0.2rem;
    }

    .closer {
        width: 0.24rem;
        position: absolute;
        top: 5px;
        right: 5px;
    }
}

.bottomBar {
    width: 7.50rem;
    box-sizing: border-box;
    padding: 0.25rem 0;
    background-color: #fff0ed;
    position: fixed;
    bottom: 0;

    p {
        width: 85%;
        height: 0.78rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;

        img {
            width: 0.37rem;
            margin-right: 0.1rem;
        }

        span {
            font-size: 0.3rem;
        }
    }

    p:nth-child(1) {
        border: 1px solid #d52226;
        border-radius: 0.5rem;
        margin-bottom: 0.2rem;

        span {
            color: #d52226;
        }
    }

    p:nth-child(2) {
        background: url('../../../../static/common/wap/botBtn.png') no-repeat;
        background-size: 100% 100%;

        span {
            color: #fff;
        }
    }
}
</style>